export const DEFAULT_BRANDING_PRIMARY_COLOR = '#0d6efd';
export const DEFAULT_BRANDING_ACCENT_COLOR = '#0d6efd';
export const SYSTEM_BRANDING_LOGO_MAX_BYTES = 1024 * 1024;

export function buildEmptySystemGeneralSettingsForm() {
  return {
    complianceMode: 'gdpr',
    dpoName: '',
    dpoEmail: '',
    dpoPhone: '',
    dataCenterCountry: '',
    dataCenterName: '',
    dataCenterAddress: '',
    allowedStorageRegionsText: '',
    appName: '',
    logoUrl: '',
    logoObjectKey: '',
    primaryColor: DEFAULT_BRANDING_PRIMARY_COLOR,
    accentColor: DEFAULT_BRANDING_ACCENT_COLOR,
  };
}

export function mergeBrandingLogoFields(currentForm, responseForm) {
  return {
    ...currentForm,
    logoUrl: responseForm?.logoUrl || '',
    logoObjectKey: responseForm?.logoObjectKey || '',
  };
}

export function validateSystemBrandingLogoFile(file) {
  if (!file) {
    return 'Choose a logo file.';
  }

  if (!['image/png', 'image/jpeg', 'image/webp'].includes(file.type)) {
    return 'Use a PNG, JPG, or WebP image.';
  }

  if (file.size > SYSTEM_BRANDING_LOGO_MAX_BYTES) {
    return 'Logo must be 1 MB or smaller.';
  }

  return '';
}
